// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Radio_componentWrapper__eBEpn","radio":"Radio_radio__R6mKu","checked":"Radio_checked__17IXL"};